import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../style/services-usa/shopify-web-development/_workflow.scss";

function WorkFlow() {
  return (
    <section className="why_choose_unity custom-workflow p-100 overflow-x-hidden">
      <Container>
        <Row className="justify-content-between">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className=""
          >
            <h2>
              <span>Custom Shopify</span> Website Development Workflow at
              TekRevol
            </h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
          >
            <p>
              When it comes to Shopify website development, we use a systematic
              approach that prioritizes flexibility and quality. Each stage
              aligns with customer preferences, uses the latest technologies,
              highlights your unique features, and adapts to eCommerce trends.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5 justify-content-center">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="why-choose-box">
              <div className="num">01</div>
              <div className="why-choose-content">
                <h5>Plan</h5>
                <p>
                  A dedicated website strategist will guide you from the project
                  start, focusing on business analysis, competitor evaluation,
                  and audience targeting. These insights are utilized to
                  deliberately and thoroughly map your Shopify website,
                  including conversion paths and unique technical features.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="why-choose-box">
              <div className="num">02</div>
              <div className="why-choose-content">
                <h5>Wireframe</h5>

                <p>
                  We take your detailed website roadmap and use it to create
                  sample high-fidelity wireframes for your home pages, which
                  help us create an efficient UX design. You can see how the
                  functions and messaging of your site are organized in these
                  wireframes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="why-choose-box">
              <div className="num">03</div>
              <div className="why-choose-content">
                <h5>UI Design</h5>
                <p>
                  During the UI design stage, we make sure to include the
                  aesthetics that will set your Shopify website apart. We create
                  clickable prototypes for you to preview animations and
                  transitions. Once the criteria are set, we move to the
                  development phase of your website design.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="why-choose-box">
              <div className="num">04</div>
              <div className="why-choose-content">
                <h5>Development & Launch</h5>
                <p>
                  After building the store, we run a QA check using a detailed
                  checklist that makes sure everything in the store from the
                  product pages to the checkout process works as intended before
                  the store goes live. As part of our Shopify eCommerce website
                  development process, we ensure the site is fast-loading, quick
                  to perform, and secure.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="why-choose-box">
              <div className="num">05</div>
              <div className="why-choose-content">
                <h5>Post Launch Maintenance</h5>
                <p>
                  Our work does not end with the launch of your Shopify website.
                  Our Shopify website design services & development include
                  ongoing maintenance and support, which means your site will be
                  constantly checked for security, upgrades, and performance
                  issues.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WorkFlow;
